<!-- eslint-disable max-len -->
<style scoped>
  .checkbox-hidden {
    display: none;
  }
  .project-goals-label {
    font-weight:normal;
  }
</style>
<template>
  <div class="view-contents" v-if="isAdmin">
    <div class="row title-row">
      <div class="col section-title">
        Targets, Objectives, and Goals Management
        <b-button
          variant="primary"
          :class="['tog-top-button', 'action-button', selectedButton !='Goal' ? 'tog-top-button-inactive' : '']"
          id="goalBtn"
          @click="selectGoal"
        >
          <span>Goal</span>
        </b-button>
        <b-button
          variant="primary"
          :class="['tog-top-button', 'action-button', selectedButton !='Objective' ? 'tog-top-button-inactive' : '']"
          id="objectiveBtn"
          @click="selectObjective"
        >
          <span>Objective</span>
        </b-button>
        <b-button
          variant="primary"
          :class="['tog-top-button', 'action-button', selectedButton !='Target' ? 'tog-top-button-inactive' : '']"
          id="targetBtn"
          @click="selectTarget"
        >
          <span>Target</span>
        </b-button>
        <span class="tog-top-button-desc">Edit: </span>
      </div>
    </div>
    <div class="section-header">
    </div>

    <div class="section-header">
      <b-overlay :show="projectObjectivesLoading">
        <div class="tog-sub-header">
            <div class="tog-newname-wrapper">
              Select:
              <b-form-select
              id='togEditDropdown'
              v-model="selectedDropdownItem"
              :options='options'
              label-field='name'
              text-field='name'
              value-field='id'
              class="m-2" size="sm"
              @change="updateAssociatedItems()">
              <template #first>
                <b-form-select-option :value="null">
                  -- {{selectedButton}} Name --
                </b-form-select-option>
              </template>
            </b-form-select>
            </div>
            <div class="tog-cancel-save-btn-wrapper">
            <b-button
              pill variant="danger" size="sm"
              class="submit-form-button btn-danger"
              @click="$router.push('TOGmanagement')">
              <span>Cancel</span>
            </b-button>
            <b-button
              pill variant="primary" size="sm"
              class="submit-form-button btn-success"
              :disabled="!isButtonActive"
              v-b-modal="'removeTOGItemModal'">
              <b-modal id="removeTOGItemModal" @ok="onUpdateOkClick()">
                <template v-slot:modal-title>
                  <span class='project-modal-warning'>Update Item</span>
                </template>
                <p>Are you sure you want to update "{{this.selectedText}}" {{this.selectedButton}}?</p>
                <template v-slot:modal-footer="{ ok, cancel }">
                  <b-button size="sm" variant="danger" @click="cancel" class='btn-danger'>No</b-button>
                  <b-button size="sm" variant="success" @click="ok" class='btn-success'>Yes</b-button>
                </template>
              </b-modal>
              <span>Save</span>
            </b-button>
            </div>
        </div>
        <div v-if="alreadyExist" class="tog-warning">It already exists.
        </div>
        <div v-if="selectedButton === 'Goal'" class="tog-priority-wrapper">
          Please select a Resource Priority<span style="color:red">*</span>:
          <b-form-select
            v-model="selectedProjectResourcePriority"
            :options='projectResourcePriorities'
            label-field='name'
            text-field='name'
            value-field='id'
            class="m-2" size="sm"
            @change="checkBtnState">
            <template #first>
              <b-form-select-option :value="null">
                -- Select a Priority for Selected Goal --
              </b-form-select-option>
            </template>
          </b-form-select>
        </div>
        <div class="tog-instruction">
          Please select associated {{this.firstReqText}}<span style="color:red">{{firstReqAsterisk}}</span>{{this.secondReqText}}<span style="color:red">{{secondReqAsterisk}}</span>:
        </div>
        <div class="row bold-title" :class="['row', 'bold-title', selectedButton ==='Goal' ? 'tog-reverse' : '']">
          <div v-if="selectedButton != 'Target'" class="col">
            <span>Targets</span><span style="color:red"  v-if="this.selectedButton === 'Objective'">*</span>
          </div>
          <div v-if="selectedButton != 'Objective'" class="col">
            <span>Objectives</span><span style="color:red"  v-if="this.selectedButton === 'Target' || this.selectedButton === 'Goal'">*</span>
          </div>
          <div v-if="selectedButton != 'Goal'" class="col">
            <span>Goals</span><span style="color:red"  v-if="this.selectedButton === 'Objective'">*</span>
          </div>
        </div>
        <div :class="['row', selectedButton ==='Goal' ? 'tog-reverse' : '']">
          <div v-if="!isTargetCheckboxListVisible && selectedButton != 'Target'" class="col site-section-wrapper">
            <div class="card card-body tog-list">
              <ul>
                <li v-for="item in projectObjectiveTargetsSelected" :key="item.id" :value="item.id">
                  {{ item.name }}
                </li>
              </ul>
            </div>
          </div>
          <div v-if="isTargetCheckboxListVisible && selectedButton != 'Target'" class="col site-section-wrapper">
            <div class="card card-body tog-list">
              <b-form-group>
                <b-form-checkbox-group v-model='selectedTargetItems' name='projectAccomplishmentTargets' class='tog-remove'>
                  <b-form-checkbox
                  :disabled = "selectedDropdownItem === null"
                  v-for="item in projectAccomplishmentTargets"
                  :id="'T-' + item.id"
                  :key="item.id"
                  :value="item.id">
                    <span class='project-goals-label'>{{ item.name }}</span>
                  </b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
            </div>
          </div>
          <div v-if="!isObjectiveCheckboxListVisible && selectedButton != 'Objective'" class="col site-section-wrapper">
            <div class="card card-body tog-list">
              <ul>
                <li v-for="item in projectObjectives" :key="item.id" :value="item.id">
                  {{ item.name }}
                </li>
              </ul>
            </div>
          </div>
          <div v-if="isObjectiveCheckboxListVisible && selectedButton != 'Objective'" class="col site-section-wrapper">
            <div class="card card-body tog-list">
              <b-form-group>
                <b-form-checkbox-group v-model='selectedObjectiveItems' name='projectObjectives' class='tog-remove'>
                  <b-form-checkbox
                  :disabled = "selectedDropdownItem === null"
                  class="tog-checkbox-label"
                  v-for="item in projectObjectives"
                  :id="'O-' + item.id"
                  :key="item.id"
                  :value="item.id">
                    <span class='project-goals-label'>{{ item.name }}</span>
                  </b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
            </div>
          </div>
          <div v-if="!isGoalCheckboxListVisible && selectedButton != 'Goal'" class="col site-section-wrapper">
            <div class="card card-body tog-list">
              <ul>
                <li v-for="item in projectObjectiveGoalsSelected" :key="item.id" :value="item.id">
                  {{ item.name }}
                </li>
              </ul>
            </div>
          </div>
          <div v-if="isGoalCheckboxListVisible && selectedButton != 'Goal'" class="col site-section-wrapper">
            <div class="card card-body tog-list">
              <b-form-group>
                <b-form-checkbox-group v-model='selectedGoalItems' name='projectGoals' class='tog-remove'>
                  <b-form-checkbox
                  :disabled = "selectedDropdownItem === null"
                  v-for="item in projectGoals"
                  :id="'G-' + item.id"
                  :key="item.id"
                  :value="item.id">
                    <span class='project-goals-label'>{{ item.name }}</span>
                  </b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
            </div>
          </div>
        </div>
      </b-overlay>
    </div>
  </div>
</template>
<script>
/* eslint-disable max-len, no-param-reassign, padded-blocks, prefer-destructuring */
import { mapState } from 'vuex';
import exitFormModal from '@/mixins/exitFormModal';
import TargetObjectiveGoalManager from '@/mixins/targetObjectiveGoalManager';

export default {
  name: 'TOGList',
  mixins: [TargetObjectiveGoalManager, exitFormModal],
  computed: {
    ...mapState(['currentSite', 'config']),
    ...mapState('Membership', {
      memberOf: (state) => state.memberOf,
    }),
    ...mapState('Project', {
      project: (state) => state.project,
      projectAccomplishmentTargets: (state) => state.projectAccomplishmentTargets,
      projectGoals: (state) => state.projectGoals,
      projectResourcePriorities: (state) => state.projectResourcePriorities,
      projectObjectives: (state) => {
        const objectives = [...state.projectObjectives].sort((a, b) => a.name.localeCompare(b.name));
        objectives.forEach((item) => {
          item.projectObjectiveAccomplishmentTargets.sort(
            (a, b) => a.projectAccomplishmentTarget.name.localeCompare(b.projectAccomplishmentTarget.name),
          );
        });

        return objectives;
      },
      projectObjectiveAccomplishmentTargetSelections: (state) => state.projectObjectiveAccomplishmentTargetSelections,
    }),
    isAdmin() {
      if (!this.config || !this.memberOf || this.memberOf.length === 0) return false;
      const viewerRoles = this.config.dashboardPage.adminRoles;
      return this.memberOf.find((item) => viewerRoles.includes(item.displayName));
    },
    selectedTargetItems: {
      get() {
        return this.selectedTargetCheckboxItems;
      },
      set(value) {
        this.selectedTargetCheckboxItems = value;
      },
    },
    selectedObjectiveItems: {
      get() {
        return this.selectedObjectiveCheckboxItems;
      },
      set(value) {
        this.selectedObjectiveCheckboxItems = value;
      },
    },
    selectedGoalItems: {
      get() {
        return this.selectedGoalCheckboxItems;
      },
      set(value) {
        this.selectedGoalCheckboxItems = value;
      },
    },
  },
  data() {
    return {
      options: [],
      selectedDropdownItem: null,
      selectedText: '',
      selectedObjectiveCheckboxItems: [],
      selectedTargetCheckboxItems: [],
      selectedGoalCheckboxItems: [],
      selectedProjectResourcePriority: null,
      firstReqText: ' objective(s)',
      firstReqAsterisk: '*',
      secondReqText: '',
      secondReqAsterisk: '',
      isButtonActive: false,
      inpVal: '',
      alreadyExist: false,
      isTargetCheckboxListVisible: false,
      isObjectiveCheckboxListVisible: true,
      isGoalCheckboxListVisible: false,
      selectedNewTargetObjectives: [],
      selectedNewGoalObjectives: [],
      selectedNewObjectiveTargets: [],
      selectedNewObjectiveGoals: [],

      projectId: null,
      projectAccomplishmentTargetsSelected: [],
      projectObjectivesLoading: false,
      projectGoalsSelected: [],
      projectObjectivesSelected: [],
      projectObjectiveGoalsSelected: [],
      projectObjectiveTargetsSelected: [],
      projectAccomplishmentTargetsLoading: true,
      selectedButton: null,
      isItemToRemoveSelected: false,
      selectedItem: null,
      selectedItemCat: null,
      selectedItemName: null,
    };
  },
  watch: {
    projectAccomplishmentTargetsSelected(newValues) {
      this.cascadeProjectTargetsSelected(newValues);
    },
    projectGoalsSelected(newValues) {
      this.cascadeProjectGoalsSelected(newValues);
    },
    projectObjectivesSelected(newValues) {

      if (this.selectedButton === 'Target') {
        this.cascadeProjectObjectivesSelectedFilterGoals(newValues);
      } else if (this.selectedButton === 'Goal') {
        this.cascadeProjectObjectivesSelectedFilterTargets(newValues);
      }
    },
    selectedTargetItems() {
      this.checkBtnState();
    },
    selectedObjectiveItems(newValues) {
      if (this.selectedButton === 'Target') {
        this.cascadeProjectObjectivesSelectedFilterGoals(newValues);
      } else if (this.selectedButton === 'Goal') {
        this.cascadeProjectObjectivesSelectedFilterTargets(newValues);
      }
    },
    selectedGoalItems() {
      this.checkBtnState();
    },
  },
  mounted() {
    (async () => {
      await this.load();
    })();
  },
  methods: {
    cascadeProjectTargetsSelected(newValues) {
      this.selectedNewObjectiveTargets = newValues;
      this.checkBtnState();
    },
    cascadeProjectGoalsSelected(newValues) {
      this.selectedNewObjectiveGoals = newValues;
      this.checkBtnState();
    },
    cascadeProjectObjectivesSelectedFilterTargets(newValues) {
      const selectedObjectives = this.projectObjectives.filter((Objective) => newValues.includes(Objective.id));

      // selectedNewGoalObjectives is used for backend
      this.selectedNewGoalObjectives = selectedObjectives.map((item) => item.id);

      // check if it is okay to enable cancel and save buttons
      this.checkBtnState();

      // update target list based on the objectives selected
      this.projectObjectiveTargetsSelected = this.getDistinctProjectTargetIds(selectedObjectives);
    },
    cascadeProjectObjectivesSelectedFilterGoals(newValues) {
      const selectedObjectives = this.projectObjectives.filter((Objective) => newValues.includes(Objective.id));

      // selectedNewTargetObjectives is used for backend
      this.selectedNewTargetObjectives = selectedObjectives.map((item) => item.id);
      this.checkBtnState();

      // update goal list based on the objectives selected
      this.projectObjectiveGoalsSelected = this.getDistinctProjectGoalIds(selectedObjectives);
    },
    cleanTextarea() {
      this.clearSelections();
      this.checkBtnState();
    },
    checkBtnState() {
      if (this.selectedDropdownItem !== null) {
        if (this.selectedButton === 'Target') {
          this.isButtonActive = (this.selectedObjectiveCheckboxItems.length > 0);
        } else if (this.selectedButton === 'Objective') {
          this.isButtonActive = (this.selectedTargetCheckboxItems.length > 0 && this.selectedGoalCheckboxItems.length > 0);
        } else if (this.selectedButton === 'Goal') {
          this.isButtonActive = (this.selectedObjectiveCheckboxItems.length > 0 && this.selectedProjectResourcePriority);

        }
      } else {
        this.isButtonActive = false;
      }
    },
    updateAssociatedItems() {
      const togEditDropdown = document.getElementById('togEditDropdown');
      this.selectedText = togEditDropdown.options[togEditDropdown.selectedIndex].text;
      this.selectedTargetCheckboxItems = [];
      this.selectedObjectiveCheckboxItems = [];
      this.selectedGoalCheckboxItems = [];
      if (this.selectedButton === 'Target') {
        this.projectObjectives.forEach((projectObjective) => {
          const index = projectObjective.projectObjectiveAccomplishmentTargets.findIndex((element) => element.projectAccomplishmentTargetId === this.selectedDropdownItem);
          if (index != null && index > -1 && !this.selectedObjectiveCheckboxItems.includes(projectObjective.id)) {
            this.selectedObjectiveCheckboxItems.push(projectObjective.id);
          }
        });
      } else if (this.selectedButton === 'Objective') {
        const targetIndex = this.projectObjectives.findIndex((projectObjective) => projectObjective.id === this.selectedDropdownItem);
        const selectedDropdownObjective = this.projectObjectives[targetIndex];
        if (targetIndex > -1) {
          selectedDropdownObjective.projectObjectiveAccomplishmentTargets.forEach((projectObjectiveAccomplishmentTarget) => {
            if (!this.selectedTargetCheckboxItems.includes(projectObjectiveAccomplishmentTarget.projectAccomplishmentTargetId)) {
              this.selectedTargetCheckboxItems.push(projectObjectiveAccomplishmentTarget.projectAccomplishmentTargetId);
            }
          });
        } else {
          this.selectedTargetCheckboxItems = [];
        }
        this.projectGoals.forEach((projectGoal) => {
          const goalIndex = projectGoal.projectGoalObjectives.findIndex((element) => element.projectObjectiveId === this.selectedDropdownItem);
          if (goalIndex != null && goalIndex > -1 && !this.selectedGoalCheckboxItems.includes(projectGoal.id)) {
            this.selectedGoalCheckboxItems.push(projectGoal.id);
          }
        });
      } else if (this.selectedButton === 'Goal') {
        const index = this.projectGoals.findIndex((projectGoal) => projectGoal.id === this.selectedDropdownItem);
        const selectedDropdownGoal = this.projectGoals[index];
        this.selectedProjectResourcePriority = selectedDropdownGoal.projectResourcePriorityId;
        selectedDropdownGoal.projectGoalObjectives.forEach((projectObjective) => {
          if (!this.selectedObjectiveCheckboxItems.includes(projectObjective.projectObjectiveId)) {
            this.selectedObjectiveCheckboxItems.push(projectObjective.projectObjectiveId);
          }
        });
        if (index > -1) {
          selectedDropdownGoal.projectGoalObjectives.forEach((projectObjective) => {
            if (!this.selectedObjectiveCheckboxItems.includes(projectObjective.projectObjectiveId)) {
              this.selectedObjectiveCheckboxItems.push(projectObjective.projectObjectiveId);
            }
          });
        } else {
          this.selectedObjectiveCheckboxItems = [];
        }
      }
      this.checkBtnState();
    },
    clearSelections() {
      this.inpVal = '';
      this.selectedNewTargetObjectives = [];
      this.selectedNewGoalObjectives = [];
      this.selectedNewObjectiveTargets = [];
      this.selectedNewObjectiveGoals = [];
      this.projectAccomplishmentTargetsSelected = [];
      this.projectObjectivesSelected = [];
      this.projectGoalsSelected = [];
      this.selectedProjectResourcePriority = null;
    },
    selectTarget() {
      this.options = this.projectAccomplishmentTargets;
      this.selectedDropdownItem = null;
      this.selectedText = '';
      this.selectedTargetCheckboxItems = [];
      this.selectedObjectiveCheckboxItems = [];
      this.selectedGoalCheckboxItems = [];
      this.clearSelections();
      this.selectedButton = 'Target';
      this.firstReqText = ' objective(s)';
      this.firstReqAsterisk = '*';
      this.secondReqText = '';
      this.secondReqAsterisk = '';
      this.isTargetCheckboxListVisible = false;
      this.isObjectiveCheckboxListVisible = true;
      this.isGoalCheckboxListVisible = false;
    },
    selectObjective() {
      this.options = this.projectObjectives;
      this.selectedDropdownItem = null;
      this.selectedText = '';
      this.selectedTargetCheckboxItems = [];
      this.selectedObjectiveCheckboxItems = [];
      this.selectedGoalCheckboxItems = [];
      this.clearSelections();
      this.selectedButton = 'Objective';
      this.firstReqText = ' target(s)';
      this.firstReqAsterisk = '*';
      this.secondReqText = ' and goal(s)';
      this.secondReqAsterisk = '*';
      this.isTargetCheckboxListVisible = true;
      this.isObjectiveCheckboxListVisible = false;
      this.isGoalCheckboxListVisible = true;
    },
    selectGoal() {
      this.options = this.projectGoals;
      this.selectedDropdownItem = null;
      this.selectedText = '';
      this.selectedTargetCheckboxItems = [];
      this.selectedObjectiveCheckboxItems = [];
      this.selectedGoalCheckboxItems = [];
      this.clearSelections();
      this.selectedButton = 'Goal';
      this.firstReqText = ' objective(s)';
      this.firstReqAsterisk = '*';
      this.secondReqText = '';
      this.secondReqAsterisk = '';
      this.isTargetCheckboxListVisible = false;
      this.isObjectiveCheckboxListVisible = true;
      this.isGoalCheckboxListVisible = false;
    },
    itemToRemove(selId) {
      this.isItemToRemoveSelected = !this.isItemToRemoveSelected;
      const targetCheckbox = document.getElementById(selId);
      if (targetCheckbox.checked) {
        this.selectedItem = selId;
        this.selectedItemName = this.getCheckboxLabelText(targetCheckbox);
        if (selId.startsWith('T-')) {
          this.selectedItemCat = 'target';
        } else if (selId.startsWith('G-')) {
          this.selectedItemCat = 'goal';
        } else if (selId.startsWith('O-')) {
          this.selectedItemCat = 'objective';
        }
      } else {
        this.selectedItem = null;
        this.selectedItemName = null;
        this.selectedItemCat = null;
      }
    },
    getCheckboxLabelText(checkboxElement) {
      if (checkboxElement.id) {
        const label = document.querySelector(`label[for="${checkboxElement.id}"]`);
        return label ? label.textContent : null;
      }
      return null;
    },
    getDistinctProjectTargetIds(selectedObjectives) {
      const ids = [];
      selectedObjectives.forEach((projectObjective) => {
        projectObjective.projectObjectiveAccomplishmentTargets.forEach((projectTarget) => {
          let isIncluded = 0;
          ids.forEach((projectTargetInIds) => {
            if (projectTargetInIds.id === projectTarget.projectAccomplishmentTargetId) {
              isIncluded += 1;
            }
          });
          if (isIncluded === 0) {
            ids.push(projectTarget.projectAccomplishmentTarget);
          }
        });
      });
      ids.sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
      return ids;
    },
    getDistinctProjectGoalIds(selectedObjectives) {
      const ids = [];
      selectedObjectives.forEach((projectObjective) => {
        this.projectGoals.forEach((projectGoal) => {
          projectGoal.projectGoalObjectives.forEach((projectGoalObjective) => {
            if (projectGoalObjective.projectObjectiveId === projectObjective.id) {
              if (!ids.includes(projectGoal)) {
                ids.push(projectGoal);
              }
            }
          });
        });
      });
      ids.sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
      return ids;
    },

    async load() {
      this.selectedButton = 'Target';
      this.refreshData();
    },
    async refreshData() {
      this.projectObjectivesLoading = true;
      await this.$store.dispatch('Project/getValidProjectGoalsAsync');
      await this.$store.dispatch('Project/getValidProjectAccomplishmentTargetsAsync');
      await this.$store.dispatch('Project/getValidProjectObjectivesAsync');
      await this.$store.dispatch('Project/getProjectResourcePriorities');
      this.projectGoals.sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
      this.projectObjectives.forEach((projectObjective) => {
        projectObjective.class = 'checkbox-hidden';

        projectObjective.projectObjectiveAccomplishmentTargetsSelected = this.projectObjectiveAccomplishmentTargetSelections.filter(
          (e) => e.projectObjectiveId === projectObjective.id,
        ).map(
          (e) => `${e.projectObjectiveId}|${e.projectAccomplishmentTargetId}`,
        );

        projectObjective.projectObjectiveAccomplishmentTargets.forEach((projectObjectiveAccomplishmentTarget) => {
          projectObjectiveAccomplishmentTarget.class = 'checkbox-hidden';
          projectObjectiveAccomplishmentTarget.childClass = 'checkbox-hidden';
        });
      });

      if (this.selectedButton === 'Target') {
        this.selectTarget();
      }
      if (this.selectedButton === 'Objective') {
        this.selectObjective();
      }
      if (this.selectedButton === 'Goal') {
        this.selectGoal();
      }
      this.projectObjectivesLoading = false;
    },
  },
};
</script>
